import { Text } from '@optiaxiom/react';

import { AgentExecutionItem } from '@frontend/types/agentExecution';

import { getTriggerType } from './utils';

type TriggerNameCellProps = {
  execution: AgentExecutionItem;
};

const getTriggerName = (execution: AgentExecutionItem): string => {
  const triggerName = execution.trigger_info?.payload?.trigger_name as string;
  if (triggerName) {
    return triggerName;
  }
  const type = getTriggerType(execution);
  return `${type} Trigger`;
};

export function TriggerNameCell({ execution }: TriggerNameCellProps) {
  return <Text fontSize="md">{getTriggerName(execution)}</Text>;
}
